import {HierarchicalIconclass} from '../types/HierarchicalIconclass';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class IconclassesService {
  public async getHierarchicalIconclasses(): Promise<HierarchicalIconclass[]> {
    return handleError(
      () => httpClient.get<HierarchicalIconclass[]>('/iconclasses/hierarchy'),
      'Error fetching iconclasses:',
      () => []
    );
  }

  public async expandKeys(code: string): Promise<HierarchicalIconclass[]> {
    return handleError(
      () => httpClient.get<HierarchicalIconclass[]>(`/iconclasses/expand/${encodeURIComponent(code)}`),
      'Error expanding iconclass keys:',
      () => []
    );
  }

  public async resolveIconclasses(codes: string[]): Promise<HierarchicalIconclass[]> {
    const params = codes.map(code => `codes=${encodeURIComponent(code)}`).join('&');
    return handleError(
      () => httpClient.get<HierarchicalIconclass[]>(`/iconclasses/resolve?${params}`),
      'Error resolving iconclasses:',
      () => []
    );
  }
}

const iconclassesService = new IconclassesService();
export default iconclassesService;

